module.exports = __webpack_public_path__ + "static/media/soundwave.730d216e.svg";